<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      合同管理
      <small>/ 合同管理列表</small>
    </h1>
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">合同管理列表</h4>
              </div>
              <!-- end panel-heading -->
              <el-card class="box-card">
                <div>

              <form  style="margin-top:16px;" >
                <fieldset>
                  <div class="form-group row m-b-15">
                    <label class="col-md-1 col-form-label">合同编号</label>
                    <div class="col-md-2">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="合同编号"
                        v-model="contractNo"
                      >
                    </div>
                   <label class="col-md-1 col-form-label">合同标题</label>
                    <div class="col-md-2">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="合同标题"
                        v-model="contractTitle"
                      >
                    </div>
                    <label class="col-md-1 col-form-label">合同签订日期</label>
                    <div class="col-md-3">
                      <el-date-picker
                        style="width:100%;height:34px;"
                        v-model="TimeValue"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="ChangePicker"
                      ></el-date-picker>
                    </div>

                    <div class="col-md-2"></div>
                    <label class="col-md-1 col-form-label LineSpacing">服务商名称</label>
                    <div class="col-md-2 LineSpacing">
                       <el-select
                          v-model="recomId"
                          style="width:100%;font-size:12px;"
                          clearable
                          filterable
                          placeholder="服务商名称"
                        >
                          <el-option
                            v-for="item in recomNameList"
                            :key="item.recomId"
                            :label="item.recomName"
                            :value="item.recomId"
                          ></el-option>
                        </el-select>
                    </div>

                    <div class="col-md-1 LineSpacing">
                      <a
                        class="btn btn-primary ButtonColor m-r-5"
                        @click="SearchClick()"
                      >查询</a>
                    </div>
                    <div class="col-md-11"></div>
                    <div class="col-md-1">
                      <a
                        class="btn btn-primary ButtonColor"
                        @click="AddClick()"
                        style="float:right;"
                      >新增</a>
                    </div>
                  </div>
                </fieldset>
              </form>
                    <el-table :data="contractList" style="width: 100%" size="medium" border >
                      <el-table-column prop="ordernumber" label="序号"  width="60"  align="center"></el-table-column>
                      <el-table-column prop="contractNo" label="合同编号" align="center" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="contractTitle" label="合同标题"  align="center" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="city" label="合同区域" align="center" show-overflow-tooltip></el-table-column>
                     <!-- <el-table-column label="合同品类" align="center" show-overflow-tooltip>
                        <template slot-scope="scope">
                          <el-popover trigger="hover">
                            <p
                              v-for="(item,index) in scope.row.goodsNameList"
                              :key="index"
                            >{{item}}</p>
                            <div
                              slot="reference"
                              class="name-wrapper SkuHover"
                            >
                              <span>{{ scope.row.goodsNameList[0] }} &nbsp;<b v-if=" scope.row.goodsNameList.length  > 1 ">...</b></span>
                            </div>
                          </el-popover>
                        </template>
                      </el-table-column>-->
                      <el-table-column prop="recomTypeName" label="客户类型" align="center" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="recomName" label="服务商名称" align="center" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="clientSignTime" label="合同签订时间" align="center" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="contractTerm" label="合同截止日期" align="center" show-overflow-tooltip></el-table-column>
                      <el-table-column prop="currentstatus" label="合同状态" align="center"></el-table-column>
                      <el-table-column prop="note" label="备注" show-overflow-tooltip ></el-table-column>
                       <el-table-column label="操作" width="250" align="center">
                         <template slot-scope="scope">
                          <el-button
                            class="btn btn-primary btn-sm ButtonColor"
                            size="small"
                            @click="DetailClick(scope.row)"
                            >合同详情
                          </el-button>
                          <el-button
                            class="btn btn-primary btn-sm ButtonColor"
                            size="small"
                            :disabled="scope.row.contractStatus == 2"
                            @click="EditClick(scope.row)"
                          >编辑</el-button>
                          <el-button
                            class="btn btn-warning btn-sm ButtonColor"
                            size="small"
                            :disabled="scope.row.contractStatus == 2"
                            @click="DeleteClick(scope.row)"
                          >删除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="bottom">
                    <div class="block">
                      <el-pagination
                        :current-page="pageNo"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount"
                        background
                      ></el-pagination>
                    </div>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
      <el-dialog title :visible.sync="outerVisible" :before-close="handleClose">
        <div class="ModelPadding">
          <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>
          <el-form
            :model="ruleForm"
            :inline="true"
            :rules="rules"
            ref="ruleForm"
            label-width="180px"
            class="demo-form-inline"
          >
            <!-- <el-form-item label="合同编号:" prop="contractNo" class="labelstyle">
              <el-input
                v-model="ruleForm.contractNo"
                placeholder="请输入合同编号"
                class="DistributorMargin InputWidth"
              ></el-input>
            </el-form-item> -->
            <el-form-item label="合同标题:" prop="contractTitle" class="labelstyle">
              <el-input
                v-model="ruleForm.contractTitle"
                placeholder="请输入合同标题"
                class="DistributorMargin InputWidth"
              ></el-input>
            </el-form-item>
            <el-form-item label="合同区域所在省:" prop="province" class="labelstyle">
              <el-select v-model="ruleForm.province" clearable filterable placeholder="请选择" style="width:220px" class="DistributorMargin" @change="proviceChange">
                <el-option
                  v-for="item in provinceList"
                  :key="item.provinceName"
                  :label="item.provinceName"
                  :value="item.provinceName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同区域所在市:" prop="city" class="labelstyle">
              <el-select v-model="ruleForm.city" clearable filterable placeholder="请选择" multiple style="width:220px" class="DistributorMargin">
                <el-option
                  v-for="item in cityList"
                  :key="item.cityName"
                  :label="item.cityName"
                  :value="item.cityName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户类型:" prop="recomType" class="labelstyle">
              <el-select
                v-model="ruleForm.recomType"
                clearable
                placeholder="请选择"
                class="DistributorMargin InputWidth"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务商名称:" prop="recomId" class="labelstyle">
              <el-select
                v-model="ruleForm.recomId"
                class="DistributorMargin InputWidth"
                clearable
                filterable
                placeholder="请输入服务商名称"
              >
                <el-option
                  v-for="item in recomNameList"
                  :key="item.recomId"
                  :label="item.recomName"
                  :value="item.recomId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同签订日期:" prop="clientSignTime" class="labelstyle">
              <div class="DistributorMargin InputWidth">
                <el-date-picker
                  v-model="ruleForm.clientSignTime"
                  type="datetime"
                  placeholder="日期"
                  @change="ChangeDate"
                  align="center"
                  class="InputWidths"
                ></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="合同截止日期:" prop="contractTerm" class="labelstyle">
              <div class="DistributorMargin InputWidth">
                <el-date-picker
                  v-model="ruleForm.contractTerm"
                  type="datetime"
                  placeholder="日期"
                  @change="ChangeDateEnter"
                  align="center"
                  class="InputWidths"
                ></el-date-picker>
              </div>
            </el-form-item>
            <el-form-item label="合同品类:" prop="goodsId" class="labelstyle">
              <el-cascader
                style="width:620px; margin-left: 16px"
                v-model="ruleForm.goodsId"
                :options="brandList"
                :props="{ multiple: true }"
                size="small"
                filterable
                clearable
              />
            </el-form-item>
             <el-form-item label="上传合同:" prop="file" class="labelstyle" >
              <div class="DistributorMargin InputWidth">
                <el-upload
                  action
                  accept=".PDF"
                  class="upload-demo"
                  :http-request="uploadPicture"
                  :file-list="fileList"
                  :limit= 1
                  :on-exceed="checkUploadNumber"
                  :before-remove="beforeRemove"
                >
                  <el-button class="btn btn-primary btn-sm ButtonColor" type="primary">点击上传</el-button>
                </el-upload>
                <span style="color: #F56C6C;font-size: 12px;" v-if="errorTip">必须上传合同</span>
              </div>
            </el-form-item>
            <el-form-item label="上传附件:" prop="accessoryUrl" class="labelstyle" >
              <div class="DistributorMargin InputWidth">
                <el-upload
                  action
                  class="upload-demo"
                  :http-request="uploadFile"
                  :file-list="ruleForm.accessoryFileList"
                  :before-remove="handleRemoveAccessoryFile"
                >
                  <el-button class="btn btn-primary btn-sm ButtonColor" type="primary">点击上传</el-button>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="备注:" prop="" class="kfSetting">
              <el-input :rows="3" v-model="ruleForm.note" type="textarea" style="width:575px;"></el-input>
            </el-form-item>
          </el-form>
          <div class="swal-footer">
            <div class="swal-button-container">
              <button
                class="swal-button swal-button--confirm btn btn-primary"
                @click="MakeSureEdit('ruleForm')"
                :disabled="disabled"
              >提交</button>
            </div>
            <div class="swal-button-container">
              <div
                class="swal-button swal-button--cancel btn btn-default"
                @click="outerVisible = false"
              >取消</div>
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog title :visible.sync="diologVisible" width="500px" :before-close="handleClose">
        <div class="ModelPadding">
          <div class="swal-icon swal-icon--info"></div>
          <div class="swal-title">您确定删除吗?</div>
          <div class="swal-footer">
            <div class="swal-button-container">
              <button class="swal-button swal-button--confirm btn btn-primary" @click="MakeSure" :disabled = "disabled">确定</button>
            </div>
            <div class="swal-button-container">
              <div
                class="swal-button swal-button--cancel btn btn-default"
                @click="diologVisible = false"
              >取消</div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import { error } from "util";
import {getFileNameFromUrl} from '../../utils/file'
export default {
  name: "contract",
  data() {
    return {
      fileList: [],
      outerVisible: false,
      diologVisible: false,
      DialogTitle: "编辑",
      disabled: false,
      CurrentSelection: [],
      ruleForm: {
        contractNo: "",
        contractTitle: "",
        recomType: "",
        note: "",
        contractTerm: "",
        province: "",
        city: "",
        brand: "",
        recomId: "",
        accessoryFileList: []
      },
      pageSize: 10,
      totalCount: 0,
      pageNo: 1,
      startTime: "",
      endTime: "",
      rules: {
        contractNo: [
          { required: true, message: "请输入合同编号", trigger: "blur" },
        ],
        contractTitle: [
          { required: true, message: "请输入合同标题", trigger: "blur" },
        ],
        recomType: [
          { required: true, message: "请选择客户类型", trigger: "blur" }
        ],
        recomId: [
          { required: true, message: "请选择服务商", trigger: "blur" }
        ],
        province: [
          {required: true, message: "请选择所在省", trigger: "blur" }
        ],
        city: [
          {required: true, message: "请选择所在市", trigger: "blur" }
        ],
        goodsId: [
          {required: true, message: "请选择合同品类", trigger: "blur" }
        ],
        contractTerm: [
          {required: true, message: "请选择合同截止日期", trigger: "blur" }
        ],
        clientSignTime: [
          {required: true, message: "请选择合同签订日期", trigger: "blur" }
        ]
      },
      brandList: [],
      typeList: [
        { key: 0, value: "服务商" },
        { key: 1, value: "分销商" }
      ],
      recomNameList: [],
      provinceList: [],
      cityList: [],
      errorTip: false,
      contractNo: "",
      contractTitle: "",
      recomId:"",
      TimeValue: "",
      TimeValueEter:"",
      contractList:[],
      director:0
    };
  },
  mounted() {
    // if(this.$route.query.director){
    //   this.director = this.$route.query.director;
    // }
    this.initData();
    this.initDatarecomNameList();
    this.initbrandData();
    this.initproviceData();
  },

  methods: {
    initData() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobContractController/selectContractPages",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: Qs.stringify({
          contractNo: that.contractNo,
          contractTitle: that.contractTitle,
          recomId: that.recomId,
          startContractTerm: that.startTime,
          endContractTerm: that.endTime,
          contractStatusList:[0,1],
          current: that.pageNo,
          size: that.pageSize,
          director: that.director
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          that.contractList = response.data.data.data.records;
          that.totalCount = response.data.data.data.total;
          for (var i in response.data.data.data.records) {
            response.data.data.data.records[i].ordernumber =
              Number((that.pageNo - 1) * that.pageSize) + Number(i) + 1;
            if (response.data.data.data.records[i].contractStatus === 0) {
              response.data.data.data.records[i].currentstatus = "拒绝审核";
            } else if (response.data.data.data.records[i].contractStatus === 1) {
              response.data.data.data.records[i].currentstatus = "未审核";
            }else if(response.data.data.data.records[i].contractStatus === 2){
                response.data.data.data.records[i].currentstatus = "已审核";
            }
            if(response.data.data.data.records[i].recomType === 0){
                response.data.data.data.records[i].recomTypeName = "服务商";
            }else if(response.data.data.data.records[i].recomType === 1){
                response.data.data.data.records[i].recomTypeName = "分销商";
            }

            if (response.data.data.data.records[i].contractTerm !== null) {
              response.data.data.data.records[i].contractTerm = that.FormatAllDate(
               response.data.data.data.records[i].contractTerm
            ).slice(0,10);
            }else {
                response.data.data.data.records[i].contractTerm = "";
            }
            if (response.data.data.data.records[i].clientSignTime !== null) {
              response.data.data.data.records[i].clientSignTime = that.FormatAllDate(
               response.data.data.data.records[i].clientSignTime
            ).slice(0,10);
            }else {
                response.data.data.data.records[i].clientSignTime = "";
            }
          }

        } else {
          http.handleHttpError(error, that);
        }
      })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    DetailClick(item){
      this.$router.push({
        path:"contractreviewdetail",
        query:{
          contractId: item.contractId,
          checkId: 3
        }
      });
    },
    proviceChange(provinceName) {
      let that = this;
      if(provinceName == ""){
        that.cityList = [];
        that.ruleForm.city = "";
      }else{
        const options = {
          url: "/distribution/B2cRegionalLinkageController/queryCity",
          method: "post",
          headers: {"Content-Type": "application/x-www-form-urlencoded"},
          data: Qs.stringify({
            provinceName: provinceName
          })
        };
        axios(options).then(response => {
          if (response.data.code == 200) {
            that.cityList = response.data.data;
            if(that.ruleForm.city){
              that.ruleForm.city = "";
            }
          } else {
            http.handleHttpError(error, that);
          }
        });
      }
    },
    queryCity(provinceName){
      let that = this;
      const options = {
        url: "/distribution/B2cRegionalLinkageController/queryCity",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          provinceName: provinceName
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.cityList = response.data.data;
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    },
    initbrandData() {
      let that = this;
      const options = {
        url: "/distribution/B2cGoodsCategoryController/queryConBrandCategory",
        method: "post",
        headers: {"Content-Type": "application/x-www-form-urlencoded"},
        data: Qs.stringify({})
      };
      axios(options).then(response => {
        if (response.data.code === 200) {
          that.brandList = (response.data.data || []).map(item => {
            return {
              value: item.brandId,
              label: item.brandName,
              ...item,
              children: (item.goodsSeries || []).map(ser => ({
                value: ser.seriesId,
                label: ser.seriesName,
                ...ser
              }))
            }
          })
        } else {
          http.handleHttpError(error, that);
        }
      });
    },
    initproviceData() {
      let that = this;
      const options = {
        url: "/distribution/B2cRegionalLinkageController/queryAllProvince",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: Qs.stringify({})
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          that.provinceList = response.data.data;
        } else {
          http.handleHttpError(error, that);
        }
      });
    },
    initDatarecomNameList() {
      let that = this;
      const options = {
        url: "/distribution/B2cRecomInfoController/getRecomInfoByCompany",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: Qs.stringify({
          director: that.director
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          that.recomNameList = response.data.data;
        } else {
          http.handleHttpError(error, that);
        }
      });
    },
    uploadPicture(param) {
      const formData = new FormData();
      formData.append("file", param.file);
      let that = this;
      const options = {
        url: "distribution/FileController/uploadFileToFast",
        method: "post",
        headers: { "Content-Type": "multipart/form-data" },
        data: formData
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.ruleForm.fileUrl = response.data.data;
            that.errorTip = false;
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },

    // 附件上传
    async uploadFile (param) {
      const data = new FormData()
      data.append('file', param.file)

      const response = await axios({
        url: 'distribution/FileController/uploadFileToFast',
        method: 'post',
        headers: {'Content-Type': 'multipart/form-data'},
        data
      }).catch(response => http.handleHttpError(response, this))

      if (response.data.code === 200) {
        if (!this.ruleForm.accessoryUrl) {
          this.ruleForm.accessoryUrl = [`${response.data.data}--${param.file.name}`]
          return
        }

        this.ruleForm.accessoryUrl.push(`${response.data.data}--${param.file.name}`)
        this.ruleForm.accessoryFileList.push({
          name: param.file.name,
          fiteUrl: response.data.data
        })
        return
      } else {
        this.ruleForm.accessoryFileList = [...(this.ruleForm.accessoryFileList || [])]
      }

      http.handleEorrorCode(response, this)
    },
    handleRemoveAccessoryFile (file) {
      this.ruleForm.accessoryUrl = (this.ruleForm.accessoryUrl || []).filter(url => url !== file.fiteUrl)
      this.ruleForm.accessoryFileList = (this.ruleForm.accessoryFileList || [])
        .filter(item => item.fiteUrl !== file.fiteUrl)
    },
    // 判断上传文件个数
    checkUploadNumber(){
      this.$notify({
        title: "提示",
        message: "合同只能上传一份，请删除后再上传",
        type: "warning"
      });
    },
    // 删除文件
    beforeRemove(){
      if(this.ruleForm.fileUrl){
        this.ruleForm.fileUrl = '';
      }
    },
    SearchClick() {
      this.pageNo = 1
      this.initData();
    },
    AddClick() {
      this.ruleForm = {
        accessoryFileList: []
      };
      this.fileList = [];
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      if(this.$refs.brand){
        this.$refs.brand.remove();
      }
      this.outerVisible = true;
      this.DialogTitle = "新增";
    },
    // 编辑函数
    EditClick (item) {
      this.outerVisible = true
      this.DialogTitle = '编辑'
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
      item.goodsId = String(item.goodsId)
      this.ruleForm = MethodsBus.cloneRow(item)
      this.ruleForm.city = item.city.split(',')

      // 附件
      this.ruleForm.accessoryFileList = (item.accessoryFileList || [])
        .filter(item => item)
        .map((item, i) => {
          const arr = String(item.fiteUrl).split('--')
          let fileName = arr[arr.length - 1]

          if (arr.length <= 1) {
            fileName = '附件' + (i + 1)
          }

          return {
            ...item,
            name: fileName
          }
        })
      this.ruleForm.accessoryUrl = this.ruleForm.accessoryFileList
        .filter(item => item)
        .map(item => item.fiteUrl)

      // 合同附件
      const [file] = item.tobFilesList || []
      this.fileList = file
        ? [ { name: item.contractTitle, url: file.fiteUrl } ]
        : []

      // 品类
      try {
        const goodsIds = JSON.parse(item.goodsId)

        this.ruleForm.goodsId = Object.keys(goodsIds).reduce((result, brandId) => {
          goodsIds[brandId].forEach(serId => {
            result.push([brandId, serId])
          })

          return result
        }, [])
      } catch (e) {
        this.ruleForm.goodsId = {}
      }

      if (this.ruleForm.province) {
        this.queryCity(this.ruleForm.province)
      }
    },
    MakeSureEdit(formName) {
      let that = this;
      if (this.DialogTitle === "编辑") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            if(that.ruleForm.tobFilesList.length > 0){
              that.ruleForm.fileUrl = that.ruleForm.tobFilesList[0].fiteUrl;
            }
            if(that.ruleForm.fileUrl){
              that.errorTip = false;
              that.disabled = true;

              let goodsId = this.ruleForm.goodsId
              try {
                goodsId = JSON.stringify((that.ruleForm.goodsId || []).reduce((result, [brandId, serielId]) => {
                  if (result[brandId]) {
                    result[brandId].push(serielId)
                  } else {
                    result[brandId] = [serielId]
                  }

                  return result
                }, {}))
              } catch (e) {
              }

              const options = {
                url: "/distribution/B2cTobContractController/editContract",
                method: "post",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                data: Qs.stringify({
                  contractId: that.ruleForm.contractId,
                  contractNo: that.ruleForm.contractNo,
                  contractTitle: that.ruleForm.contractTitle,
                  province: that.ruleForm.province,
                  city: that.ruleForm.city.toString(),
                  goodsId,
                  recomType: that.ruleForm.recomType,
                  contractTerm: that.ruleForm.contractTerm,
                  clientSignTime: that.ruleForm.clientSignTime,
                  fileUrl: that.ruleForm.fileUrl,
                  recomId: that.ruleForm.recomId,
                  note: that.ruleForm.note,
                  accessoryUrl: (this.ruleForm.accessoryUrl || []).join(';')
                })
              }
              axios(options).then((response)=> {
                that.disabled = false;
                if (response.data.code == 200) {
                  that.outerVisible = false;
                  that.initData();
                  that.$notify({
                    title: "成功",
                    message: response.data.message,
                    type: "success"
                  });
                } else {
                  that.disabled = false;
                  http.handleEorrorCode(response, that);
                }
              })
              .catch((error)=> {
                that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              });
            }else{
              that.errorTip = true;
              that.disabled = false;
            }
          } else {
            that.outerVisible = true;
            that.disabled = false;
          }
        });
      } else if (this.DialogTitle === "新增") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            console.log((that.ruleForm.goodsId || []).reduce((result, [brandId, serielId]) => {
              if (result[brandId]) {
                result[brandId].push(serielId)
              } else {
                result[brandId] = [serielId]
              }

              return result
            }, {}))
            if(that.ruleForm.fileUrl){
              that.errorTip = false;
              that.disabled = true;
              const options = {
                url: "/distribution/B2cTobContractController/addContract",
                method: "post",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                data: Qs.stringify({
                  contractTitle: that.ruleForm.contractTitle,
                  province: that.ruleForm.province,
                  city: that.ruleForm.city.toString(),
                  goodsId: JSON.stringify((that.ruleForm.goodsId || []).reduce((result, [brandId, serielId]) => {
                    if (result[brandId]) {
                      result[brandId].push(serielId)
                    } else {
                      result[brandId] = [serielId]
                    }

                    return result
                  }, {})),
                  recomType: that.ruleForm.recomType,
                  contractTerm: that.ruleForm.contractTerm,
                  clientSignTime:that.ruleForm.clientSignTime,
                  fileUrl: that.ruleForm.fileUrl,
                  recomId: that.ruleForm.recomId,
                  note: that.ruleForm.note,
                  accessoryUrl: (this.ruleForm.accessoryUrl || []).join(';')
                })
              };
              axios(options).then((response)=> {
                that.disabled = false;
                if (response.data.code == 200) {
                  that.outerVisible = false;
                  that.initData();
                  that.$notify({
                    title: "成功",
                    message: response.data.message,
                    type: "success"
                  });
                } else {
                  that.disabled = false;
                  http.handleEorrorCode(response, that);
                }
              })
              .catch((error)=> {
                that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              });
            }else{
              that.errorTip = true;
              that.disabled = false;
            }
          } else {
            that.outerVisible = true;
            that.disabled = false;
          }
        });
      }
    },
    DeleteClick(item) {
      this.diologVisible = true;
      this.CurrentSelection = item;
    },
    MakeSure() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobContractController/delContract",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          contractNo: that.CurrentSelection.contractNo
        })
      };
      axios(options)
        .then(response => {
          that.diologVisible = false;
          if (response.data.code == 200) {
            that.initData();
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    handleSizeChange(value) {
      this.pageSize = value;
      this.pageNo = 1;
      this.initData();
    },
    handleCurrentChange(value) {
      this.pageNo = value;
      this.initData();
    },
    ChangePicker() {
      if (this.TimeValue !== null) {
        this.startTime = this.FormatAllDate(this.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.TimeValue[1]);
      } else if (this.TimeValue === null) {
        this.startTime = "";
        this.endTime = "";
      }
    },
    ChangeDate(){
      this.ruleForm.clientSignTime = this.FormatAllDate(this.ruleForm.clientSignTime);
    },
  ChangeDateEnter(){
      this.ruleForm.contractTerm = this.FormatAllDate(this.ruleForm.contractTerm);
    },

    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
    FormatSpecialDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() + seperator1 + month + seperator1 + strDate;

      return currentdate;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.area {
  margin-right: 50px;
}
.ButtonColor {
  color: #fff !important;
}
.contractScopelist {
  margin-left: -8px;
}
.ModelPadding {
  margin-top: -20px;
  text-align: left;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth {
  width: 220px;
}
.InputWidths {
  width: 190px;
}
.province {
  width: 180px;
}
.city {
  width: 202px;
  margin-left: 20px;
}
.selectpage {
  display: flex;
  margin-left: 22px;
}
.upload {
  margin-top: 20px;
  margin-left: 18%;
  display: flex;
  color: #606266;
  font-size: 14px;
  font-weight: 600;
  justify-content: flex-start;
}
.upload_left {
  /* margin-top: 20px; */
  padding-right: 20px;
  letter-spacing: 1px;
}
.upload_right {
  margin-top: 45px;
}
.item {
  margin-bottom: 18px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}
.bottom {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

</style>



// WEBPACK FOOTER //
// src/components/ContractManagement/Contract.vue